
// Core
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SynchronymeComponent } from './synchronyme.component';


const routes: Routes = [
    {
        path: "dev/:type",
        component: SynchronymeComponent
    },
    {
        path: ":type/:midOfficeRef",
        component: SynchronymeComponent
    },
    {
        path: ":type/:midOfficeRef/:midOfficeRefType",
        component: SynchronymeComponent
    },
    {
        path: "dev/:type/:midOfficeRef/:PNRId",
        component: SynchronymeComponent
    },
    {
        path: "",
        component: SynchronymeComponent
    },

];

@NgModule({
    imports: [ RouterModule.forChild(routes) ],
    exports: [ RouterModule ]
})
export class SynchronymeRoutingModule {}
